import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs';
import { LobI } from 'src/app/interfaces/lob.interface';
import { BackendResponse } from 'src/app/interfaces/response.interface';
import { handleError } from 'src/app/tools/tools';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class LobService {
  constructor(private readonly http: HttpClient) {}

  private readonly url = environment.url + 'lob/';

  getAll(params?: HttpParams) {
    const direction = this.url + 'get/all-filter';
    return this.http.get<BackendResponse>(direction, { params }).pipe(
      catchError((e) => handleError(e)),
      map(
        (data) =>
          data.result as {
            entities: LobI[];
            count: number;
          }
      )
    );
  }
}
